import request from './request';
import requestWithoutTimeout from './requestWithoutTimeout';

const orderService = {
  getAll: (params) =>
    request.get('dashboard/admin/orders/paginate', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/orders/${id}`, { params }),
  export: (params) =>
    requestWithoutTimeout.get(`dashboard/admin/order/export`, { params }),
  create: (data) => request.post('dashboard/admin/orders', data, {}),
  update: (id, data) => {
    const { currency_id, ...rest } = data || {};
    return request.put(`dashboard/admin/orders/${id}`, rest);
  },
  calculate: (params) =>
    request.get(`dashboard/admin/order/products/calculate${params}`),
  updateStatus: (id, data) =>
    request.post(`dashboard/admin/order/${id}/status`, data, {}),
  updateDelivery: (id, params) =>
    request.post(`dashboard/admin/order/${id}/deliveryman`, {}, { params }),
  delete: (params) =>
    request.delete(`dashboard/admin/orders/delete`, { params }),
  dropAll: () => request.get(`dashboard/admin/orders/drop/all`),
  restoreAll: () => request.get(`dashboard/admin/orders/restore/all`),
  getAllUserOrder: (id, params) =>
    request.get(`dashboard/admin/user-orders/${id}/paginate`, { params }),
  getUserTopProducts: (id, params) =>
    request.get(`dashboard/admin/user-orders/${id}`, { params }),
  replaceProduct: (id, data) => {
    const { currency_id, ...rest } = data || {};
    return request.put(`dashboard/admin/orders/${id}`, rest);
  },
  updateTracking: (id, data) =>
    request.post(`dashboard/admin/order/${id}/tracking`, data),
  getByParentId: (id, params) =>
    request.get(`dashboard/admin/orders/${id}/get-all`),
  // Send OTP for order deletion
  sendOtp: (orderId) =>
    request.post('dashboard/admin/orders-send-otp', { order_id: orderId }),
  // Delete orders with OTP (supports multiple ids)
  deleteWithOtp: (ids, otp) => {
    const params = Array.isArray(ids)
      ? Object.assign(
          { otp },
          ...ids.map((id, index) => ({ [`ids[${index}]`]: id }))
        )
      : { otp, 'ids[0]': ids };
    return request.delete('dashboard/admin/orders/delete', { params });
  },
  // Get cancellation reasons
  getCancellationReasons: () =>
    request.get('rest/cancellation-reasons'),
  // Cancel order with reasons
  cancelOrder: (id, data) =>
    request.post(`dashboard/user/orders/${id}/cancel-and-refund`, data),
};

export default orderService;
